export default "__VITE_ASSET__BBef5pRz__"